/** Inclusion rules for picking display fields from a cached row. */
const RULES = {
	// Skip null/undefined so a cache miss never blanks a Typesense value.
	present: (value) => value != null,
	// Allow null so clearing a field overlays the Typesense value.
	nullable: (value) => value !== undefined,
	// Skip empty ids.
	truthy: Boolean,
};

/**
 * Builds a picker that copies display fields from a cached row (RTK Query) for overlaying
 * onto a Typesense/search row.
 *
 * schema: { [field]: 'present' | 'nullable' | 'truthy' | { rule?, transform? } }
 */
export const createDisplayFieldPicker = (schema) => {
	const entries = Object.entries(schema).map(([field, spec]) => {
		const { rule = 'present', transform } = typeof spec === 'string' ? { rule: spec } : spec;
		return { field, include: RULES[rule], transform };
	});

	return (source) => {
		const fields = {};

		if (!source || typeof source !== 'object') {
			return fields;
		}

		for (const { field, include, transform } of entries) {
			const value = source[field];
			if (include(value)) {
				fields[field] = transform ? transform(value) : value;
			}
		}

		return fields;
	};
};

/** Overlay picked cache fields onto a Typesense/search row. */
export const mergeRowWithCachedFields = (row, cachedFields) => {
	if (!row) {
		return cachedFields ? { ...cachedFields } : row;
	}

	if (!cachedFields || Object.keys(cachedFields).length === 0) {
		return row;
	}

	return { ...row, ...cachedFields };
};
